import { actions } from '@app/store/action/errors';

export default function (state = {}, action = {}) {
  const { type, form, errors, key } = action;
  switch (type) {
    case actions.ERROR_SET:
      return {
        ...state,
        [form]: errors,
      };

    case actions.ERROR_RESET:
      if (state[form]) {
        delete state[form][key];
      }

      return {
        ...state,
      };

    case actions.ERRORS_FORM_RESET:
      delete state[form];

      return {
        ...state,
      };
  }

  return state;
}
